<style scoped>

</style>
<template>
  <div>
    <Tabs
      type="card"
      @on-click="tabChange"
    >
      <TabPane
        name="asset_device_type"
        label="设备类型"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_device_type',new_asset_device_type)"
          >
            添加
          </Button>
        </div>
        <div class="line">
          <Table
            :columns="asset_device_type_columns"
            :data="asset_device_types"
          />
          <Backdrop v-show="is_asset_device_type_loading" />
        </div>
      </TabPane>
      <TabPane
        name="asset_name"
        label="资产名称"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_name',new_asset_name)"
          >
            添加
          </Button>
          <div style="display:inline-block;margin-left:10px">
            <Input
              v-model="asset_name_params.search"
              placeholder="请输入搜索内容..."
              style="width: 300px;margin-right:10px"
              clearable
              @on-clear="assetNameSearch"
            />
            <Button 
              icon="ios-search"
              type="primary"
              :loading="is_asset_name_loading"
              @click="assetNameSearch"
            >
              搜索
            </Button>
          </div>
        </div>
        <div class="line">
          <Table
            :columns="asset_name_columns"
            :data="asset_names"
          />
          <Backdrop v-show="is_asset_name_loading" />
        </div>
      </TabPane>
      <TabPane
        name="asset_version"
        label="资产型号"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_version', new_asset_version)"
          >
            添加
          </Button>
          <div style="display:inline-block;margin-left:10px">
            <Input
              v-model="asset_version_params.search"
              placeholder="请输入搜索内容..."
              style="width: 300px;margin-right:10px"
              clearable
              @on-clear="assetVersionSearch"
            />
            <Button 
              icon="ios-search"
              type="primary"
              :loading="is_asset_version_loading"
              @click="assetVersionSearch"
            >
              搜索
            </Button>
          </div>
        </div>
        <div class="line">
          <Table
            :columns="asset_version_columns"
            :data="asset_versions"
          />
          <Backdrop v-show="is_asset_version_loading" />
        </div>
      </TabPane>
      <TabPane
        name="asset_order_name"
        label="资产申请名称"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_order_name',new_asset_order_name)"
          >
            添加
          </Button>
        </div>
        <div class="line">
          <Table
            :columns="asset_order_name_columns"
            :data="asset_order_names"
          />
          <Backdrop v-show="is_asset_order_name_loading" />
        </div>
      </TabPane>
      
      <TabPane
        name="asset_brand"
        label="设备品牌"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_brand',new_asset_brand)"
          >
            添加
          </Button>
        </div>
        <div class="line">
          <Table
            :columns="asset_brand_columns"
            :data="asset_brands"
          />
          <Backdrop v-show="is_asset_brand_loading" />
        </div>
      </TabPane>
      <TabPane
        name="asset_location"
        label="资产位置"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_location',new_asset_location)"
          >
            添加
          </Button>
        </div>
        <div class="line">
          <Table
            :columns="asset_location_columns"
            :data="asset_locations"
          />
          <Backdrop v-show="is_asset_location_loading" />
        </div>
      </TabPane>
      <TabPane
        name="asset_stock"
        label="资产仓库"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_stock',new_asset_stock)"
          >
            添加
          </Button>
        </div>
        <div class="line">
          <Table
            :columns="asset_stock_columns"
            :data="asset_stocks"
          />
          <Backdrop v-show="is_asset_stock_loading" />
        </div>
      </TabPane>
      <TabPane
        name="asset_purpose"
        label="资产用途"
      >
        <div class="line">
          <Button
            type="primary"
            icon="md-add"
            @click="editItem('asset_purpose',new_asset_purpose)"
          >
            添加
          </Button>
        </div>
        <div class="line">
          <Table
            :columns="asset_purpose_columns"
            :data="asset_purposes"
          />
          <Backdrop v-show="is_asset_purpose_loading" />
        </div>
      </TabPane>
    </Tabs>

    <div
      v-show="asset_name_page_info.total && mode === 'asset_name'"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="asset_name_page_info.current"
        :total="asset_name_page_info.total"
        :page-size="asset_name_page_info.page_size"
        @on-change="function(new_page){pageChange('asset_name', new_page)}"
      />
    </div>
    <div
      v-show="asset_device_type_page_info.total && mode === 'asset_device_type'"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="asset_device_type_page_info.current"
        :total="asset_device_type_page_info.total"
        :page-size="asset_device_type_page_info.page_size"
        @on-change="function(new_page){pageChange('asset_device_type', new_page)}"
      />
    </div>
    <div
      v-show="asset_brand_page_info.total && mode === 'asset_brand'"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="asset_brand_page_info.current"
        :total="asset_brand_page_info.total"
        :page-size="asset_brand_page_info.page_size"
        @on-change="function(new_page){pageChange('asset_brand', new_page)}"
      />
    </div>

    <div
      v-show="asset_location_page_info.total && mode === 'asset_location'"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="asset_location_page_info.current"
        :total="asset_location_page_info.total"
        :page-size="asset_location_page_info.page_size"
        @on-change="function(new_page){pageChange('asset_location', new_page)}"
      />
    </div>

    <div
      v-show="asset_stock_page_info.total && mode === 'asset_stock'"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="asset_stock_page_info.current"
        :total="asset_stock_page_info.total"
        :page-size="asset_stock_page_info.page_size"
        @on-change="function(new_page){pageChange('asset_stock', new_page)}"
      />
    </div>

    <div
      v-show="asset_version_page_info.total && mode === 'asset_version'"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="asset_version_page_info.current"
        :total="asset_version_page_info.total"
        :page-size="asset_version_page_info.page_size"
        @on-change="function(new_page){pageChange('asset_version', new_page)}"
      />
    </div>

    <Modal
      v-model="edit_asset_name_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_name_config.loading"
      @on-ok="editOK('asset_name')"
    >
      <div class="line">
        <span>名称:</span>
        <i-input v-model.trim="edit_asset_name.name" />
      </div>
      <div class="line">
        <span>设备类型:</span>
        <Select
          v-model="edit_asset_name.asset_device_type_id"
        >
          <Option
            v-for="item in assetDeviceTypes.arr"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </Option>
        </Select>
      </div>
      <div class="line">
        <span>备注:</span>
        <i-input
          v-model.trim="edit_asset_name.desc"
          type="textarea"
        />
      </div>
    </Modal>
    <Modal
      v-model="edit_asset_order_name_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_order_name_config.loading"
      @on-ok="editOK('asset_order_name')"
    >
      <div class="line">
        <span>名称:</span>
        <i-input v-model.trim="edit_asset_order_name.name" />
      </div>
      <div class="line">
        <span>备注:</span>
        <i-input
          v-model.trim="edit_asset_order_name.desc"
          type="textarea"
        />
      </div>
    </Modal>
    <Modal
      v-model="edit_asset_device_type_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_device_type_config.loading"
      @on-ok="editOK('asset_device_type')"
    >
      <div class="line">
        <span>名称:</span>
        <i-input v-model.trim="edit_asset_device_type.name" />
      </div>
      <!--  <div class="line">
        <span>备注:</span>
        <i-input
          v-model.trim="edit_asset_device_type.desc"
          type="textarea"
        />
      </div> -->
    </Modal>
    <Modal
      v-model="edit_asset_brand_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_brand_config.loading"
      @on-ok="editOK('asset_brand')"
    >
      <div class="line">
        <span>名称:</span>
        <i-input v-model.trim="edit_asset_brand.name" />
      </div>
      <div class="line">
        <span>备注:</span>
        <i-input
          v-model.trim="edit_asset_brand.desc"
          type="textarea"
        />
      </div>
    </Modal>
    <Modal
      v-model="edit_asset_location_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_location_config.loading"
      @on-ok="editOK('asset_location')"
    >
      <div class="line">
        <span>地点名称:</span>
        <i-input v-model.trim="edit_asset_location.name" />
      </div>
    </Modal>
    <!-- 设备用途 -->
    <!-- edit_asset_purpose_config -->
    <Modal
      v-model="edit_asset_purpose_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_purpose_config.loading"
      @on-ok="editOK('asset_purpose')"
    >
      <div class="line">
        <span>设备用途:</span>
        <i-input v-model.trim="edit_asset_purpose.name" />
      </div>
    </Modal>
    <Modal
      v-model="edit_asset_stock_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_stock_config.loading"
      @on-ok="editOK('asset_stock')"
    >
      <div class="line">
        <span>仓库名称:</span>
        <i-input v-model.trim="edit_asset_stock.name" />
      </div>
      <div class="line">
        <span>仓库类型:</span>
        <Select v-model="edit_asset_stock.asset_stock_type">
          <Option :value="1">
            普通仓库
          </Option>
          <Option :value="0">
            废弃仓库
          </Option>
        </Select>
      </div>
      <div class="line">
        <span>备注:</span>
        <i-input
          v-model.trim="edit_asset_stock.desc"
          type="textarea"
        />
      </div>
    </Modal>
    <Modal
      v-model="edit_asset_version_config.modal"
      width="400"
      title="添加 / 编辑"
      ok-text="保存"
      :mask-closable="false"
      :loading="edit_asset_version_config.loading"
      @on-ok="editOK('asset_version')"
    >
      <div class="line">
        <span>资产型号:</span>
        <i-input v-model.trim="edit_asset_version.name" />
      </div>
      <div class="line">
        <span>设备类型:</span>
        <Select v-model="edit_asset_version.asset_device_type_id">
          <Option
            v-for="item in assetDeviceTypes.arr"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </Option>
        </Select>
      </div>
      <div class="line">
        <span>资产名称:</span>
        <Select v-model="edit_asset_version.asset_name_id">
          <Option
            v-for="item in assetNames.arr"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </Option>
        </Select>
      </div>
    </Modal>
  </div>
</template>
<script route="/exec/asset_setting">
  import Util from '../../libs/util';
  import { type_need_keys } from './fields'
  export default {
    /* router_info_start */
    router_info: '/exec/asset_setting',
    /* router_info_end */
    data() {
      this.asset_base_data = Util.api.asset_base_data
      return {
        mode: 'asset_name',
        asset_name_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_order_name_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_device_type_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_brand_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_location_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_stock_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_purpose_params: {
          search: '',
          page: 1,
          per_page: 20
        },
        asset_name_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_order_name_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_device_type_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_brand_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_location_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_stock_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_purpose_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_version_page_info: {
          current: 1,
          total: 0,
          page_size: 20
        },
        asset_version_params: {
          asset_device_type_id: null,
          asset_name_id: null,
          query_type: "page",
          search: '',
          page: 1,
          per_page: 20
        },
        asset_name_columns: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '设备类型',
            render: (h, {row}) => {
              if ([null, '', undefined].includes(row.asset_device_type_id)) {
                return <span>-</span>
              }
              return h('span', (this.assetDeviceTypes.hash[row.asset_device_type_id] || {}).name)
            }
          },
          {
            title: '备注',
            key: 'desc'
          },
          {
            title: '操作',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editItem('asset_name', params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确认删除吗？',
                        onOk: () => {
                          this.deleteItem('asset_name', params.row)
                        }
                      })
                    }
                  }
                }, '删除')
              ])
              // return ;
            }
          }
        ],
        asset_order_name_columns: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '备注',
            key: 'desc'
          },
          {
            title: '操作',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editItem('asset_order_name', params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '你确定要删除吗?',
                        onOk: () => {
                          this.deleteAssetOrderName(params.row.id).then(() => {
                            this.$Message.success('删除成功')
                            this.queryItem('asset_order_name')
                          })
                        }
                      })
                    }
                  }
                }, '删除'),
              ]);
            }
          }
        ],
        asset_device_type_columns: [
          {
            title: '名称',
            key: 'name'
          },
          /*   {
            title: '备注',
            key: 'desc'
          }, */
          {
            title: '操作',
            render: (h, params) => {
              return h("div", [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editItem('asset_device_type', params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确认删除吗？',
                        onOk: () => {
                          this.deleteItem('asset_device_type', params.row)
                        }
                      })
                    }
                  }
                }, '删除')
              ])
            }
          }
        ],
        asset_brand_columns: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '备注',
            key: 'desc'
          },
          {
            title: '操作',
            render: (h, params) => {
              return h("div", [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editItem('asset_brand', params.row) // todo
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确认删除吗？',
                        onOk: () => {
                          this.deleteItem('asset_brand', params.row)
                        }
                      })
                    }
                  }
                }, '删除')
              ])
            }
          }
        ],
        asset_purpose_columns: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '操作',
            render: (h, params) => {
              return h("div", [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editItem('asset_purpose', params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确认删除吗？',
                        onOk: () => {
                          this.deleteItem('asset_purpose', params.row)
                        }
                      })
                    }
                  }
                }, '删除')
              ])
            }
          }
        ],
        asset_location_columns: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '操作',
            render: (h, params) => {
              return h("div", [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editItem('asset_location', params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确认删除吗？',
                        onOk: () => {
                          this.deleteItem('asset_location', params.row)
                        }
                      })
                    }
                  }
                }, '删除')
              ])
            }
          }
        ],
        asset_stock_columns: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '类型',
            key: 'type',
            render: (h, params) => {
              return h('div', params.row.asset_stock_type === 0 ? '废弃仓库' : '普通仓库')
            }
          },
          {
            title: '备注',
            key: 'desc'
          },
          {
            title: '操作',
            render: (h, params) => {
              return h("div", [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editItem('asset_stock', params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确认删除吗？',
                        onOk: () => {
                          this.deleteItem('asset_stock', params.row)
                        }
                      })
                    }
                  }
                }, '删除')
              ])
              
            }
          }
        ],
        asset_version_columns: [
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '资产名称',
            key: 'asset_name',
          },
          {
            title: '设备类型',
            key: 'asset_device_type'
          },
          {
            title: '操作',
            render: (h, params) => {
              return h("div", [
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editItem('asset_version', params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确认删除吗？',
                        onOk: () => {
                          this.deleteItem('asset_version', params.row)
                        }
                      })
                    }
                  }
                }, '删除')
              ])
              
            }
          }
        ],
        new_asset_name: {
          id: 0,
          name: '',
          desc: ''
        },
        new_asset_order_name: {
          id: 0,
          name: '',
          desc: ''
        },
        new_asset_device_type: {
          id: 0,
          name: '',
          desc: ''
        },
        new_asset_brand: {
          id: 0,
          name: '',
          desc: ''
        },
        new_asset_purpose: {
          id: 0,
          name: '',
        },
        new_asset_location: {
          id: 0,
          name: ''
        },
        new_asset_stock: {
          id: 0,
          name: '',
          desc: ''
        },
        new_asset_version: {
          id: null,
          asset_device_type_id: 0,
          asset_name_id: 0,
          name: ""
        },
        asset_names: [],
        asset_order_names: [],
        asset_device_types: [],
        asset_brands: [],
        asset_stocks: [],
        asset_purposes: [],
        asset_locations: [],
        asset_versions: [],
        edit_asset_name: {
          name:'',
          asset_device_type_id:'',
          desc:''
        },
        edit_asset_order_name: {},
        edit_asset_device_type: {},
        edit_asset_brand: {},
        edit_asset_location: {},
        edit_asset_stock: {},
        edit_asset_purpose: {},
        edit_asset_version: {
          name: "",
          asset_name_id: "",
          asset_device_type_id: "",
        },
        edit_asset_name_config: {
          modal: false,
          loading: true
        },
        edit_asset_order_name_config: {
          modal: false,
          loading: true
        },
        edit_asset_device_type_config: {
          modal: false,
          loading: true
        },
        edit_asset_brand_config: {
          modal: false,
          loading: true
        },
        edit_asset_location_config: {
          modal: false,
          loading: true
        },
        edit_asset_stock_config: {
          modal: false,
          loading: true
        },
        edit_asset_purpose_config: {
          modal: false,
          loading: true
        },
        edit_asset_version_config: {
          modal: false,
          loading: true
        },
        is_asset_name_loading: false,
        is_asset_order_name_loading: false,
        is_asset_device_type_loading: false,
        is_asset_brand_loading: false,
        is_asset_location_loading: false,
        is_asset_stock_loading: false,
        is_asset_purpose_loading:false,
        is_asset_version_loading: false,
        base_data: {}
      }
    },
    computed: {
      assetDeviceTypes() {
        const arr = this.base_data.asset_device_types || []
        const hash = arr.reduce((hash_map, item) => {
          hash_map[item.id] = item
          return hash_map
        }, {})
        return {
          arr,
          hash
        }
      },
      assetNames() {
        const arr = this.base_data.asset_names || []
        const hash = arr.reduce((hash_map, item) => {
          hash_map[item.id] = item
          return hash_map
        }, {})
        return {
          arr,
          hash
        }
      },
    },
    created() {
      this.queryItem('asset_name');
      this.queryItem('asset_order_name')
      this.queryItem('asset_device_type');
      this.queryItem('asset_brand');
      this.queryItem('asset_location');
      this.queryItem('asset_stock');
      this.queryItem('asset_purpose');
      this.queryItem('asset_version');
    },
    mounted() {
      Util.http.get(Util.api.asset_base_data).then(data => {
        Object.keys(data).forEach(key => {
          this.$set(this.base_data, key, data[key])
        })
        // this.base_data = data || {}
      })
      //
    },
    methods: {
      deleteAssetOrderName(id) {
        return Util.ajax.post(Util.api.delete_asset_order_name, {
          id
        })
      },
      tabChange(name) {
        this.mode = name;
        if (name === 'asset_name') {
          this.queryItem('asset_device_type')
        }
      },
      editItem(type, item) {
        const data_key = `edit_${type}`
        const data_config_key = `edit_${type}_config`
        const need_keys = type_need_keys[data_key]
        const current_data = Util.clone(item)
        if (!need_keys) {
          this[data_key] = current_data;
          this[data_config_key].modal = true;
          return 
        }
        need_keys.forEach(key => {
          this.$set(this[data_key], key, current_data[key])
        })
        this[data_config_key].modal = true;
      },
      deleteItem(type, item) {
        const loading_key = `is_${type}_loading`;
        if (!this[loading_key]) {
          this[loading_key] = true;
          Util.ajax.post(Util.api[`delete_${type}`], {
            id: item.id
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this[loading_key] = false;
            if (res.code === 1) {
              this.queryItem(type)
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this[loading_key] = false;
            console.log(e);
            this.$Modal.error({
              title: '错误',
              content: e.message
            });
          });
        }
      },
      queryItem(type) {
        // asset_purpose query_asset_stock
        const loading_key = `is_${type}_loading`;
        if (!this[loading_key]) {
          this[loading_key] = true;
          Util.ajax.get(Util.api[`query_${type}`], {
            params: this[`${type}_params`]
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this[loading_key] = false;
            if (res.code === 1) {
              const data = res.data;
              this[`${type}s`] = [];
              data.items.forEach((item) => {
                this[`${type}s`].push(item);
              });
              this[`${type}_page_info`].current = data.cur_page;
              this[`${type}_page_info`].page_size = data.per_page;
              this[`${type}_page_info`].total = data.total_count;
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this[loading_key] = false;
            console.log(type)

            console.log(e);
            this.$Modal.error({
              title: '错误',
              content: e.message
            });
          });
        }
      },
      pageChange(type, new_page) {
        this[`${type}_params`].page = new_page;
        this.queryItem(type);
      },
      editOK(type) {
        const config_key = `edit_${type}_config`;
        Util.ajax.post(Util.api[`update_${type}`], this[`edit_${type}`]).then((response) => {
          return response.data;
        }).then((data) => {
          this[config_key].loading = false;
          setTimeout(() => {
            this[config_key].loading = true;
          }, 500);
          if (data.code === 1) {
            this[config_key].modal = false;
            if (type === "asset_version") {
              this.queryItem('asset_version');
            } else {
              Util.insertOrUpdateArrayItem(this[`${type}s`], data.data, true);
            }
          }
        }).catch((e) => {
          this[config_key].loading = false;
          setTimeout(() => {
            this[config_key].loading = true;
          }, 500);
          console.log(e);
        });
      },
      assetNameSearch() {
        this.asset_name_params.page = 1
        this.$nextTick(() => {
          this.queryItem('asset_name');
        })
      },
      assetVersionSearch() {
        this.asset_version_params.page = 1;
        this.$nextTick(() => {
          this.queryItem('asset_version');
        })
      }
    }
  }
</script>
